import { render, staticRenderFns } from "./InternalTrackingNumber.vue?vue&type=template&id=df161668&scoped=true"
import script from "./InternalTrackingNumber.vue?vue&type=script&lang=js"
export * from "./InternalTrackingNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df161668",
  null
  
)

export default component.exports